function apiBaseUrl() {
  return process.env.REACT_APP_API_BASE_URL;
}

export function apiV2Invoices(withDraft=false) {
  if(withDraft) {
    return `${apiBaseUrl()}/api/v2/invoices?with_draft_from=2019-02-19`;
  } else {
    return `${apiBaseUrl()}/api/v2/invoices`;
  }
}

export function apiV2Invoice(id, userId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/invoices/${id}`;
}

export function apiV2InvoiceAttachments(id, userId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/invoices/${id}/invoice_attachments`;
}

export function apiV2InvoiceNotifications(id, userId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/invoices/${id}/fca_notifications?fca_page=trade_document_show&last=true`;
}

export function apiV2InvoiceResolveNotifications(id, userId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/invoices/${id}/resolve_fca_notifications`;
}



// WEBPACK FOOTER //
// ./src/features/trade_documents/invoicesApiUrls.js